import { render } from "./rightsDetail.vue?vue&type=template&id=4bb42399"
import script from "./rightsDetail.vue?vue&type=script&lang=js"
export * from "./rightsDetail.vue?vue&type=script&lang=js"

import "./rightsDetail.vue?vue&type=style&index=0&id=4bb42399&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__